import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import ArtistCard from "./ArtistCard";
import { useApp } from "../context/AppContext";
import { supabase } from "../lib/supabase.js";

const norm = (a, fromSupa) => ({
  id:           fromSupa ? a.id   : a._id,
  _mongoId:     fromSupa ? null   : a._id,
  name:         a.name          || "",
  name_ar:      a.name_ar       || "",
  specialty:    a.specialty     || "",
  specialty_ar: a.specialty_ar  || "",
  country:      a.country       || a.address || "",
  intro:        a.intro         || a.Intro || a.biography || "",
  intro_ar:     a.intro_ar      || "",
  photo_url:    a.photo_url     || a.profileImage || "",
  images:       Array.isArray(a.images) ? a.images : [],
  website:      a.website   || "",
  email:        a.email     || "",
  telephone:    a.telephone || "",
  fromSupa,
});

const Artists = () => {
  const { t, lang } = useApp();
  const isAr = lang === "ar";
  const [artists, setArtists] = useState([]);
  const [status,  setStatus]  = useState("loading");
  const [query,   setQuery]   = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await supabase
          .from("artists")
          .select("*")
          .eq("status", "approved")
          .eq("is_visible", true)
          .order("sort_order", { nullsFirst: false })
          .order("name");

        if (data && data.length > 0) {
          setArtists(data.map((a) => norm(a, true)));
        } else {
          const r = await axios.get("/api/artists");
          setArtists((r.data.artists || []).map((a) => norm(a, false)));
        }
        setStatus("ready");
      } catch {
        setStatus("error");
      }
    };
    load();
  }, []);

  const q = query.trim().toLowerCase();
  const shown = q
    ? artists.filter((a) =>
        [a.name, a.name_ar, a.specialty, a.specialty_ar, a.country, a.intro, a.intro_ar]
          .filter(Boolean).some((v) => v.toLowerCase().includes(q))
      )
    : artists;

  return (
    <>
      <div className="page-band">
        <div className="container">
          <h1>{t("ourArtists")}</h1>
          <p>{t("ourArtistsSub")}</p>
        </div>
      </div>

      <section className="section container">
        <div className="field" style={{ marginBottom: 30 }}>
          <input
            className="input"
            placeholder={t("searchArtists")}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>

        {status === "loading" && <div className="empty-state">{t("loading")}</div>}
        {status === "error"   && <div className="empty-state">Could not load artists.</div>}
        {status === "ready" && shown.length === 0 && (
          <div className="empty-state">
            <p>{t("noArtists")}{q ? ` — "${query}"` : ""}.</p>
            <Link className="btn btn-primary" to="/register">{t("beFirst")}</Link>
          </div>
        )}

        <div className="artist-grid">
          {shown.map((a) => <ArtistCard key={a.id} artist={a} isAr={isAr} />)}
        </div>
      </section>
    </>
  );
};

export default Artists;
